// Translations.js
const translations = {
  en: {
    entername: 'Enter Name',
    Activities: 'Activities',
    basicField: 'Basic  Fields',
    selectionfield: 'Selection field',
    mediafield: 'Media and Special Fields',
    items: 'items',
    Enable: 'Enable',
    disable: 'Disable',
    comapletedDate: 'Completed Date',
    taskId: 'taskId',
    noproject: 'No Project',
    nodepartment: 'No Department',
    noactivity: 'No Activity',
    splaignrule: 'Special Assignment Rule',
    myprofile: 'My Profile',
    barChart: 'Bar Chart',
    Piechart: 'Pie chart',
    Radarchart: 'Radar chart',
    Linechart: 'Line chart',
    Areachart: 'Area chart',
    OrganizationLogo: 'Organization Logo',
    OrganizationName: 'Organization Name',
    OrganizationId: 'Organization Id',
    Organizations: 'Organizations',
    ReportType: 'Report Type',
    ForInstallmentPlan: 'For Installment Plan',
    WorkflowNames: 'Workflow Names',
    ReportLink: 'Report Link',
    RequestedAt: 'Requested At',
    Noguidelines: 'No guidelines available',
    Deleteworkflowmsg: 'Do you really want to leave? This action will delete your created workflow structure',
    MandatoryFields: 'Mandatory Field',
    NonMandatoryFields: 'Non-Mandatory Fields',
    BulkUpload: 'Bulk Upload',
    CreateandAssigne: 'Create and Assigne',
    AssetName: 'Asset Name',
    UserId: 'User Id',
    FieldStaffList: "Field Staff List",
    SUBMISSION: 'SUBMISSION',
    NOT_COMPLETED: 'NOT_COMPLETED',
    HideCriteria: "Hide Criteria",
    NewCriteria: 'Add New Criteria',
    ActivityQuestions: 'Select Activity Questions',
    FieldQuestion: 'Select Field Question',
    Select: 'Select',
    AddChart: 'Add Chart',
    DeleteDash: 'Are you sure you want to delete this dashboard?',
    DeleteGraph: 'Are you sure you want to delete this graph metric?',
    CreateDash: 'Create Activity Dashboard',
    Role: 'Role',
    Activity: 'Activity',
    ActivityName: 'Activity Name',
    SelectChart: 'Select Chart',
    ViewChart: 'View Chart',
    RangeFilter: 'Date Range Filter',
    selecrOrg: 'Please select an organization',
    Page: 'Page',
    FieldId: 'Field Agent ID',
    FieldAgentName: 'Field Agent Name',
    NoasssingData: 'No assignee data available',
    Action: 'Action',
    RemarkReq: 'Remarks are required.',
    adCustSupport: 'Add customer Support',
    Clone: 'Clone',
    SpecialRc: 'Special RC',
    InteractiveRc: 'Interactive RC',
    Viewinstallment: 'View installment',
    createInstallment: 'Create installment plan',
    CustomerId: 'Customer Id',
    NoOfinstallment: 'Number of installments ',
    advancepayamt: 'Advance Payment Amount',
    advDate: 'Advance Date',
    custDetail: 'Customer Details',
    instalDetail: 'Installment Details ',
    firstInstDate: 'First Installment Date ',
    clrPreview: 'Clear Preview',
    prevPlan: 'Preview Plan ',
    submitRc: 'Submit for Rc',
    AfterAdv: 'Outstanding After Advance',
    currentOut: 'Current outstanding',
    payDate: 'Payment date',
    Amount: 'Amount ',
    Notes: 'Notes ',
    Latitude: 'Latitude ',
    Longitude: 'Longitude ',
    selectFieldAget: 'Select Field Agent ',
    planId: 'Plan Id',
    planActive: 'Plan Active ',
    planCreated: 'Plan Created',
    outstaningAmt: 'Outstanding Amount',
    Advamt: 'Advance Amount',
    AdvDate: 'Advance Payment Date',
    firstInsDate: 'First Installment Date',
    noOfInst: 'No of Installments',
    activeInst: 'Active Installments',
    DetailId: 'Detail Id ',
    PaymentId: 'Payment Id,',
    PayAmt: 'Payment Amount ',
    payDate: 'Payment date ',
    Status: 'Status ',
    PayPrev: 'Payment Preview',
    OutAfteAdv: 'Outstanding After Advance',
    CurrentOut: 'Current outstanding ',
    NoinstAvlble: 'No installment available ',
    title: 'Blufield Utilities Tasks management solutions',
    userEmail: 'Username/Email address ',
    remember: 'Remember me',
    forgetpass: 'Forget password',
    Login: 'Login ',
    pressEnter: 'Press Enter to add multiple account numbers',
    typeEnter: 'Type a number and press Enter',
    Phone: 'Phone',
    payDetail: 'Payment Details',
    cretDate: 'Created Date',
    inactiveplane: 'Inactive Installment Plans',
    instplanDetail: 'Installment Plan Details',
    loogoutMsg: 'Are you sure you want to logout?',
    Logout: "Logout",
    support: "Customer Support",
    supporttooltip: "RC Support System",
    powerbidashboard: "PowerBi Dashboard",
    installment: "Installment Plan",
    password: "Password",
    noDatavb: "No Data available",
    viewValidation: "view Validation",
    completedTaskCount: "Completed Task Count",
    priority: " Task Priority",
    taskstatus: "Task Status",
    previous: "Prev",
    next: "Next",
    datefilterforchart: " Date for Completed Task",
    date: "Date",
    from: "From",
    to: "To",
    apply: "Apply",
    unassignn: "Un-Assign",
    dashboard: "Dashboard",
    dashboardtolltip: "Dashboard,View and manage your dashboard overview",
    usertooltip: "Users, Manage user accounts and roles",
    setting: "Settings",
    asset: "Asset Management",
    assettooltip: "Asset, View and manage your assets",
    config: "Configuration",
    configtooltip:
      "Configuration, Manage Assignment rules, custom rules and completion rules",
    task: "Task Manage",
    tasktooltip: "Task Manage, Manage your tasks and assignments, deletion",
    acchistory: "Account History",
    historytooltip: "Account History, View the history of completed tasks",
    workflowe: "Workflow",
    workflowtooltip: "Workflow, Manage your workflows, Guidelines",
    worklog: "Worklog",
    worklogtooltip:
      "Worklog, View and manage your work logs, Export Excel Report, Export PDF",
    security: "Security",
    securitytooltip: "Security, Manage security settings",
    report: "Reports",
    reportooltip: "Reports, Request for report, Check status of the Reports",
    org: "Organization",
    orgtooltip: "Organization, Manage Organization",
    stock: "Stock Management",
    stocktoooltip:
      "Stock Management, Update inventory Details, Download Report",
    //USER
    addUser: "Add User",
    searchusername: "Search by username...",
    searchareacode: "Search by areacode...",
    userType: "User Type",
    user: "User",
    edit: "Edit",
    userlist: "User Management",
    userdetail: "User Details",
    previllage: "Previleges",
    cancle: "Cancel",
    updateuser: "Update User",
    add: "Add User",
    username: "User Name",
    Email: "Email",
    selectOrg: "Select Organization",
    areCode: "Area Code",
    addeditActivity: "Add/edit Activity",
    addnewlabel: "Add/Edit Configuration",
    addEdituser: "Add/edit User",
    canasset: "Can access asset Management",
    uservisibility: " User Visibility",
    modifyguidline: "Modifying Guidelines",
    createDashboar: "Create Dashboard",
    addeditleader: "Add/edit Leader-board",
    canTaskManage: "Can access Task Manage",
    canAddEditProtectedAccount: "Can Add /Edit Protected account",
    canAddEditInventory: "Can add/Edit Inventory Management",
    //SETTINGS
    general: "General",
    save: "Save Changes",
    langSetting: "Language Settings",
    colormode: "Color Mode",
    light: "Light",
    dark: "Dark",
    highcontrast: "High Contrast",
    lang: "Language",
    toursetting: "Tour Setting",
    stoptour: "Stop Tour",
    starttour: "Start Tour",
    custommarker: "Custom Marker",
    all: "All",
    assigned: "Assigned",
    active: "Active",
    progress: "In Progress",
    completed: "Completed",
    onhold: "On Hold",
    //ASSET
    vehical: "Vehical",
    Inventory: "Inventory",
    exportreport: "Export Report",
    addVehical: "Add New Vehical",
    addAsset: " Add New Asset",
    search: "Search",
    vehicalType: "Vehicle type",
    vehicalAssign: "Vehicle Assignee",
    searchbyId: "Search By Id...",
    assetType: "Asset type",
    assetAssign: "Asset Assignee",
    addnewasset: "Add New Asset",
    assetId: "Asset ID",
    agentAssigned: "Agent Assigned",
    assetStatus: "Asset Status",
    updateAsset: "Update Asset",
    Update: "Update",
    updateVehical: "Update Vehical",
    //CONFIGURATION
    complitionrule: "Completion Rules",
    assignment: "Assignment Rules",
    customerule: "Custom Variables",
    rulename: "Rule Name",
    assignTo: "Assign To",
    assingTask: 'Assign Tasks',
    activedeactive: "Active / Deactive",
    criteria: "Criteria",
    submit: "Submit",
    update: "Update",
    norule: "No more rules to load",
    icon: "Icon",
    createrule: "Create new rule",
    //TASKMANAGE
    multiSelect: "Multi Select",
    smartAssign: "Smart Assign",
    FieldStaff:"Field Staff",
    Location:"Location",
    MapStatus:"Map Status",
    fieldAgent: "Field Agent",
    createNewTask: " Create new task",
    importCSV: "Upload Task",
    mapview: "Mapview",
    createTask: "Create new task",
    listvbiew: "Task List View",
    download: "Download",
    downloadPdf: "Download PDF",
    refresh: "Refresh Table",
    deleteAllRecord: " Delete All Record",
    assign: "Assign",
    reassign: "Re-Assign",
    usercount: "User Counts",
    alert: "Sent Alert",
    delete: "Delete",
    priority: "Priority",
    status: "Status",
    searchbycode: "Search by Area Code..",
    selectAssign: "Select Assignee",
    downloadtask: " Download Task Report",
    seectallactivty: " Select All Activity",
    selectpartcular: " Selected Particular Activity",
    selectMsg: "Please select an activity to proceed.",
    createnewtask: "Create new task",
    cancel: "Cancel",
    create: "Create",
    DragDetail: "Drag and drop CSV containing all the task details",
    sizeMsg: "Max file size: 15MB",
    import: " Import CSV ",
    uploadfile: "Upload Task Sheet",
    uploadby: "Uploaded By",
    uploaddate: "Upload Date",
    uploadtime: "Upload Time (24hrs)",
    taskdetail: "Task Detail",
    taskhistory: " Task History",
    nohistory: "No task history available.",
    more: "Loading more task history...",
    enteraccno: " Enter Account Number",
    reset: " Reset",
    submitting: "Submitting..",
    accDetail: " Account Details",
    accnumber: "Account Number",
    area: "Area",
    areacode: "Area Code",
    latitude: "Latitude",
    longitude: "Longitude",
    importdb: "Import Master DB",

    exportData: " Export Report",
    downloading: "Downloading...",
    viewGuideline: "View Guideline",
    createWorkflow: "Create new Workflow",
    selectOrgWarning: "Select organization first",
    guidline: "Guidlines",
    noworkflow: "No workflows available",
    pleaseselect: " Please select a workflow first.",
    email: "  Schedule email report",
    export: "Export Report",
    pdf: "Export PDF",
    todo: "To do",
    loading: "Loading more worklog...",
    nomore: "No more worklog to load",
    name: "Protected Account",
    createacc: "Create new account",

    editacc: "Edit Protected Account",
    createproacc: "Create Protected Account",
    permanent: "Permanent Protection",
    protectionValid: "Protection Valid to",
    createdBy: "createdBy",
    accProtection: "Account Protection for All Activity",
    accno: "Account No",
    remark: "Remarks",
    enterremark: "Enter your remarks here",
    updatemeterDEtail: "Update Meter Details",
    downloadsheet: "Download Sheet",
    uploadinventory: "Upload Inventory Sheet",
    reportType: "Report Type",

    form: "Request Report",
    uploadSheet: "Upload Sheet",
    startDate: "Start Date",
    endDate: " End Date",
    request: "Request",

    orglist: " Orgnizations List",
    createOrg: " Create Orgnization",
    noOrg: " No organization data available.",
    rows: "Rows per page",
    orgname: "Organization Name",
    img: "  Upload Logo",

    creating: "Creating...",
    updateOrg: "Update Organization",

    Updating: "Updating...",
    nolog: "No Logo",
    number: "No.",
    geoCodes :"Selected Geo Codes",
    typeCodes :"Selected Type Codes",
    amountRange :"Selected Amount Range",
    assignAll :"Assign All",
    default:"Default",
    //dashbord
    userdashboard: "User Dashboard",
    activitydashboard: "Activity Dashboard",
    admin: "Admin",
    office_user: "Office Users",
    field_agent: "Field Agents",
    dashboardName: "Dashboard Name",
    addnewDashboard: "Add New Dashboard",
    chartMessage: " Select the Dashboard to view charts",
    deletDashbord: "Delete Dashboard",
    //notifucation
    notification: "Notification",
    allnotification: "All Notification",
    profile: "Profile",
    select: " Select Activity",
    selecteOrgName: "Select Organization",
    selectsubactivty: "Select Subactivity",

    emailreport: "Schedule Email Report",
    selectactivity: "Select the activity:",
    recipients: "Recipients",
    bcc: "Bcc",
    cc: "Cc",
    sendreport: "Send scheduled report",
    senddashboard: "Send Dashboard:",
    shedulesend: "Schedule send:",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",

    send: "Send",
    reportbtn: "Request Report",
    report: "Reports",

    stockmanag: "Stock Management",
    fromdate: "From Date",
    todate: "To Date",
    metercode: "Meter Bar Code",
    location: "To Location",
    filter: "Apply Filters",
    addbtn: "Add",
    updatetaskdetail: "Update Task Details",
    discard: "Discard",
    Confirm: "Confirm",
    visitTime: "Visit Time",
    visitDate: "Visit Date",
    nopdfavb: "No PDF available",

    // login
    Utilities: "Utilities &",
    TasksManagementSolutions: "Tasks Management Solutions",
    UsernameEmailAddress: "Username / Email Address",
    RememberMe: "Remember Me",
    ForgotPassword: "Forgot Password?",
    assetBarCode: "Asset Barcode",
    dragAndDropDocuments: "Drag and drop Documents",
    viewDocuments: "View Documents",
    uploadedDocument: "Uploaded Document",
    maxFileSize5MB: "Max file size: 5MB",
    browse: "Browse",
    description: "Description",
    kilometer: "Kilometer",
    noAccountDetialsAvailable: "No account details available",
    uploading: "Uploading",
    upload: "Upload",
    addOrganization: "Add Organization",
    addDepartment: "Add Department",
    uploadOrganizationLogo: "Upload Organization Logo",
    successMessage: "Please wait! The file is being uploaded. It may take some time, and once successfully uploaded, you will receive a success message.",
    fullName: "Full Name",
    department: "Department",
    project: "Project",
    profileImage: "Profile Image",
    vehicleId: "Vehicle ID",
    vehicleKM: "Vehicle (KM)",
    vehicleAssinged: "Vehicle Assigned",
    editPrivileges: "Edit Privileges",
    source: "Source",
    thecustomcodewarningmessage: "The custom marker color not added, select from below !!",
    selectWorkflowFirst: "Select workflow first",
    makerColor: "Marker colors saved successfully!",
    failedtoSaveMakerColor: "Failed to save marker color!",
    permanentProtection: "Permanent protection will not have an end date",
    noRecordAvailable: "No record Available",
    reportGenerating: "Report is Generating...",
    mediumPriority: "Medium Priority",
    highPriority: "High Priority",
    lowPriority: "Low Priority",
    fillFieldbeforeAddVehical: "Please fill all the fields before adding vehicle",
    failToAddVehical: "Failed to add vehicle",
    accountProtection:"Account Protection",
    clockIn:"clock in",
    clockOut:"clock out",
    English: "English",
    Urdu:"Urdu",
    Arabic:"Arabic",
    History: "History",
    Heading:"Heading",
    Name:"Name",
    Email:"Email",
    Phone:"Phone",
    Address: "Address",
    DatePicker: "Date Picker",
    TakePhoto: "Take Photo",
    Signature: "Signature",
    RadioButton: "Radio Button",
    Checkbox: "Checkbox",
    Dropdown: "Dropdown",
    Number: "Number",
    Time: "Time",
    LongText: "Long Text",
    Barcode: "Barcode",
    NotificationSound:"Notification Sound",
    TestSound:"Test Sound",
    Configurations:"Configurations",
    TermsAndConditions:"Terms and Conditions",
    DragDropTermsConditionFile:"Drag and drop Terms and Condition file",
    PrivacyAcceptance:"Privacy Acceptance",
    DragDropPrivacyAcceptanceFile :"Drag and drop Privacy Acceptance file",
    TermsandConditionPdf:"TermsandCondition.pdf",
    view:"view",
    NoReportDataavailble:"No Report Data availble",
    UnexpectedResponseFormat:"Unexpected response format. Please try again.",
    chooseFile: "Choose File",
    noFile: "No file chosen",
    PasswordRequired:"Password is required",
    PasswordMustBeAtLeast8Characters:"Password must be at least 8 characters",
    IncludeDeletedRecords:"Include Deleted Records",
  },
  ar: {
    entername: 'أدخل الأسم',
    Activities: 'الأنشطة',
    basicField: 'الحقول الأساسية',
    selectionfield: 'حقل الاختيار',
    mediafield: 'وسائل الاعلام والمجالات الخاصه ',
    items: 'العناصر',
    Enable: 'تمكين',
    disable: 'تعطيل',
    comapletedDate: 'تاريخ الإكمال',
    taskId: 'معرف المهمة',
    noproject: 'لا توجد مشاريع',
    nodepartment: ' لا توجد أقسام',
    noactivity: ' لا توجد أنشطة',
    splaignrule: 'قاعدة المهام الخاصة',
    myprofile: "ملفي الشخصي",
    barChart: 'مخطط شريطي',
    Piechart: ' مخطط دائري',
    Radarchart: ' مخطط الرادار',
    Linechart: 'مخطط خطي',
    Areachart: 'مخطط مساحي',
    OrganizationLogo: 'شعار المنظمة',
    OrganizationName: 'اسم المنظمة',
    OrganizationId: 'معرف المنظمة',
    Organizations: 'المنظمات',
    ReportType: ' نوع التقرير',
    ForInstallmentPlan: ' لخطة التقسيط',
    WorkflowNames: ' أسماء سير العمل',
    ReportLink: 'رابط التقرير',
    RequestedAt: ' تم الطلب في',
    Noguidelines: 'لا توجد إرشادات متاحة',
    Deleteworkflowmsg: ' هل تريد المغادرة حقًا؟ هذا الإجراء سيؤدي إلى حذف هيكل سير العمل الذي أنشأته',
    MandatoryFields: 'لحقول الإلزامية',
    NonMandatoryFields: ' الحقول غير الإلزامية',
    BulkUpload: 'رفع جماعي',
    CreateandAssigne: 'إنشاء وتعيين',
    AssetName: 'اسم الأصل',
    UserId: 'معرف المستخدم',
    FieldStaffList: "قائمة موظفي الميدان",
    SUBMISSION: 'إرسال',
    NOT_COMPLETED: 'غير مكتمل',
    HideCriteria: "إخفاء المعايير",
    NewCriteria: 'إضافة معيار جديد',
    ActivityQuestions: 'اختر أسئلة النشاط',
    FieldQuestion: 'اختر سؤال الحقل',
    Select: 'اختر',
    AddChart: 'إضافة مخطط',
    DeleteDash: 'هل أنت متأكد أنك تريد حذف لوحة المعلومات هذه؟',
    DeleteGraph: 'هل أنت متأكد أنك تريد حذف هذا المقياس البياني؟',
    CreateDash: 'إنشاء لوحة معلومات للنشاط',
    Role: 'الدور',
    Activity: 'النشاط',
    ActivityName: 'اسم النشاط',
    SelectChart: 'اختر مخطط',
    ViewChart: 'عرض المخطط',
    RangeFilter: 'مرشح نطاق التاريخ',
    selecrOrg: ' يرجى اختيار منظمة',
    Page: 'الصفحة',
    FieldId: 'رقم تعريف موظف الميدان',
    FieldAgentName: 'اسم موظف الميدان',
    NoasssingData: ' لا توجد بيانات للمُكلّف',
    Action: 'إجراء',
    RemarkReq: 'الملاحظات مطلوبة',

    adCustSupport: 'إضافة دعم العملاء',
    Clone: 'نسخ',
    SpecialRc: 'خاص RC',
    InteractiveRc: 'تفاعلي RC',
    Viewinstallment: 'عرض القسط ',
    createInstallment: 'إنشاء خطة تقسيط',
    CustomerId: 'معرف العميل',
    NoOfinstallment: 'عدد الأقساط',
    advancepayamt: 'مبلغ الدفع المقدم',
    advDate: ' تاريخ الدفع المقدم',
    custDetail: 'تفاصيل العميل',
    instalDetail: 'تفاصيل القسط',
    firstInstDate: 'تاريخ أول قسط',
    clrPreview: 'مسح المعاينة',
    prevPlan: ' معاينة الخطة',
    submitRc: 'Rc إرسال  ',
    AfterAdv: 'المستحقات بعد دفع المقدم',
    currentOut: 'المستحقات الحالية',
    payDate: 'تاريخ الدفع',
    Amount: 'المبلغ ',
    Notes: 'الملاحظات ',
    Latitude: 'خط العرض  ',
    Longitude: ' خط الطول ',
    selectFieldAget: ' اختيار الموظف ميداني',
    planId: 'رقم الخطة',
    planActive: 'الخطة نشطة',
    planCreated: 'تم إنشاء الخطة',
    outstaningAmt: 'المبلغ المستحق',
    Advamt: 'مبلغ المقدم',
    AdvDate: ' تاريخ دفع المقدم',
    firstInsDate: 'تاريخ أول قسط',
    noOfInst: ' عدد الأقساط',
    activeInst: 'الأقساط النشطة',
    DetailId: 'رمز التفاصيل',
    PaymentId: 'رمز الدفع',
    PayAmt: 'مبلغ الدفع',
    payDate: 'تاريخ الدفع',
    Status: 'الحالة ',
    PayPrev: 'معاينة الدفع',
    OutAfteAdv: 'المبلغ المستحق بعد دفع المقدم ',
    CurrentOut: 'المبلغ المستحق الحالي ',
    NoinstAvlble: 'لا توجد أقساط متاحة',
    title: 'حلول إدارة المهام من بلوفيلد ',
    userEmail: 'اسم المستخدم / عنوان البريد الإلكتروني',
    remember: 'تذكرني',
    forgetpass: 'نسيت كلمة المرور',
    Login: 'تسجيل الدخول ',
    pressEnter: 'اضغط إدخال لإضافة أرقام حسابات متعددة',
    typeEnter: 'اكتب رقمًا واضغط إدخال',
    Phone: 'رقم الهاتف',
    payDetail: 'تفاصيل الدفع',
    cretDate: 'تاريخ الإنشاء',
    inactiveplane: 'خطط التقسيط غير النشطة',
    instplanDetail: 'تفاصيل خطة التقسيط',
    loogoutMsg: 'هل أنت متأكد أنك تريد تسجيل الخروج؟',
    Logout: " تسجيل الخروج",
    support: "دعم العملاء",
    supporttooltip: "نظام الدعم  RC",
    powerbidashboard: "لوحة معلومات PowerBI",
    installment: "خطة التقسيط",
    password: "كلمة المرور",
    downloadPdf: "تحميل PDF",
    noDatavb: "لا تتوفر بيانات",
    viewValidation: "عرض التحقق من الصحة",
    refresh: " تحديث الجدول",
    discard: "إلغاء",
    Confirm: "تأكيد",
    datefilterforchart: "مرشح التاريخ للمهام المكتملة",
    updatetaskdetail: "تحديث تفاصيل المهمة",
    completedTaskCount: "عدد المهام المكتملة  ",
    priority: "أولوية ",
    taskstatus: "حالة المهمة",
    request: "طلب",
    usercount: "أعداد المستخدمين",
    listvbiew: "عرض قائمة المهام",
    addbtn: "يضيف",
    unassignn: "إلغاء التعيين",
    assingTask: 'تعيين المهام',
    date: "التاريخ",
    from: "من",
    to: "إلى",
    apply: "تطبيق",
    previous: "السابق",
    next: "التالي",
    profile: "حساب تعريفي",
    uploadSheet: " تحميل الورقة",

    //notification
    notification: "إشعار",
    allnotification: "كل الإخطار",
    //dashbord
    deletDashbord: "حذف لوحة المعلومات",
    workflow: "سير العمل",
    dashboard: "لوحة القيادة",
    userdashboard: "لوحة تحكم المستخدم",
    activitydashboard: "لوحة معلومات النشاط",
    admin: "مسؤول ",
    office_user: "مستخدمي المكتب",
    field_agent: "موظفين الميدان",
    dashboardName: "اسم لوحة المعلومات",
    addnewDashboard: "إضافة لوحة تحكم جديدة",
    chartMessage: "حدد لوحة المعلومات لعرض المخططات",

    dashboardtolltip:
      "لوحة المعلومات، عرض وإدارة نظرة عامة على لوحة المعلومات الخاصة بك",
    usertooltip: "المستخدمون، إدارة حسابات المستخدمين والأدوار",
    asset: "إدارة الأصول",
    assettooltip: "الأصول وعرض وإدارة الأصول الخاصة بك",
    config: "قواعد التعيين",
    configtooltip:
      "التكوين وإدارة قواعد التعيين والقواعد المخصصة وقواعد الإكمال",
    task: "إدارة المهام",
    tasktooltip: "إدارة المهام، إدارة المهام والواجبات الخاصة بك، والحذف",
    acchistory: "سجل الحساب",
    historytooltip: "سجل الحساب، عرض تاريخ المهام المكتملة",
    workflowe: "سير العمل",
    workflowtooltip: "سير العمل، إدارة سير العمل الخاص بك، المبادئ التوجيهية",
    worklog: "سجل العمل",
    worklogtooltip:
      "سجل العمل، عرض وإدارة سجلات العمل الخاصة بك، تصدير تقرير Excel، تصدير PDF",


    security: "حماية",
    securitytooltip: "الأمان، إدارة إعدادات الأمان",
    report: "التقارير",
    reportooltip: "التقارير، طلب التقرير، التحقق من حالة التقارير",
    org: "منظمة",
    orgtooltip: "التنظيم، إدارة المنظمة",
    stock: "إدارة المخزون",
    stocktoooltip: "إدارة المخزون، تحديث تفاصيل المخزون، تنزيل التقرير",
    //USER
    addUser: "إضافة مستخدم",
    searchusername: "البحث حسب اسم المستخدم...",
    searchareacode: "البحث عن طريق رمز المنطقة...",
    userType: "نوع المستخدم",
    user: "مستخدم",
    edit: "يحرر",
    userlist: "إدارة المستخدمين ",

    userdetail: "تفاصيل المستخدم",
    previllage: "الامتيازات",
    cancle: "إلغاء",
    updateuser: "تحديث المستخدم",
    add: "إضافة مستخدم",
    username: "اسم المستخدم",
    Email: "بريد إلكتروني",
    selectOrg: "حدد المنظمة",
    areCode: "كود المنطقة",
    addeditActivity: "إضافة/تعديل النشاط ",
    addnewlabel: "إضافة/تحرير التكوين     ",
    addEdituser: "إضافة/تحرير مستخدم",
    canasset: "يمكن الوصول إلى إدارة الأصول",
    uservisibility: "رؤية المستخدم",
    modifyguidline: "تعديل المبادئ التوجيهية",
    createDashboar: "إنشاء لوحة المعلومات",
    addeditleader: "إضافة/تحرير لوحة المتصدرين",

    canTaskManage: "يمكن الوصول إلى إدارة المهام",
    canAddEditProtectedAccount: "يمكن إضافة/تحرير الحساب المحمي",
    canAddEditInventory: "يمكن إضافة/تحرير إدارة المخزون",

    //SETTING
    general: "عام",
    save: "حفظ التغييرات",
    setting: "إعدادات",
    langSetting: "إعدادات اللغة",
    colormode: "وضع اللون",
    light: "ضوء",
    dark: "مظلم",
    highcontrast: "التباين العالي",
    lang: "لغة",
    toursetting: "إعداد الجولة",
    stoptour: "توقف الجولة",
    starttour: "ابدأ الجولة",
    custommarker: "علامة مخصصة",
    all: "الجميع",
    assigned: "مهام",
    active: "نشيط ",
    progress: "قيد التنفيذ",
    completed: "مكتمل",
    onhold: "في الانتظار",

    //ASSET
    vehical: "مركبة",
    Inventory: "جرد",
    exportreport: "تصدير تقرير",
    addVehical: "أضف مركبة جديدة",
    addAsset: "إضافة أصول جديدة",
    search: "يبحث",

    vehicalType: "نوع المركبة",
    vehicalAssign: "المكلف بالمركبة",
    searchbyId: "البحث بالمعرف...",
    assetType: "نوع الأصول",
    assetAssign: "المكلف بالأصول",
    addnewasset: "إضافة تأكيد جديد",
    assetId: "معرف الأصل",
    agentAssigned: "الوكيل المعين",
    assetStatus: "حالة الأصل",
    updateAsset: "تحديث الأصول",
    Update: "تحديث",
    updateVehical: "تحديث المركبة",

    //CONFIGURATION
    complitionrule: "قواعد الإكمال",
    assignment: "قواعد التعيين",
    customerule: "المتغيرات المخصصة",
    rulename: "اسم القاعدة",
    assignTo: "تعيين ل",
    activedeactive: "نشط / غير نشط",
    criteria: "معايير",
    submit: "إرسال",
    update: "تحديث",
    norule: "لا مزيد من القواعد للتحميل",
    icon: "رمز",
    createrule: "إنشاء قاعدة جديدة",

    multiSelect: "تحديد متعدد",
    smartAssign: "التعيين الذكي",
    FieldStaff:"الموظفين الميدانيين",
    Location:"موقع",
    MapStatus:"حالة الخريطة",
    fieldAgent: "الموظف الميداني",
    createNewTask: "إنشاء مهمة جديدة",
    importCSV: "  تحميل المهمة",
    mapview: "عرض الخريطة",
    createTask: "إنشاء مهمة جديدة",
    download: "تحميل",
    deleteAllRecord: "حذف كافة السجلات",
    assign: "المكلف",


    reassign: "إعادة التعيين",
    alert: "تنبيه مرسل",
    delete: "حذف ",
    priority: "أولوية",
    status: "الحالة ",
    searchbycode: "البحث عن طريق رمز المنطقة..",
    selectAssign: "حدد المكلف",
    downloadtask: " تنزيل تقرير المهام",
    seectallactivty: "حدد كل الأنشطة",
    selectpartcular: " نشاط معين محدد",
    selectMsg: "الرجاء تحديد نشاط للمتابعة.",
    createnewtask: "إنشاء مهمة جديدة",
    cancel: "إلغاء",
    create: "إنشاء",

    //import csv
    DragDetail: "قم بسحب وإسقاط ملف CSV الذي يحتوي على جميع تفاصيل المهمة",
    sizeMsg: "الحد الأقصى لحجم الملف: 15 ميجابايت",
    import: "CSV إستيراد ملف",
    uploadfile: "تحميل قائمة المهام",
    uploadby: "تم الرفع بواسطة",
    uploaddate: "تاريخ التحميل",
    uploadtime: "وقت التحميل (24 ساعة)",

    //taskd etail
    taskdetail: "تفاصيل المهمة",
    taskhistory: "سجل المهام",
    nohistory: "لا يوجد سجل مهام متاح.",
    more: "جارٍ تحميل المزيد من سجل المهام...",

    //task hisotry
    enteraccno: "أدخل رقم الحساب",
    reset: "إعادة تعيين",
    submitting: "جارٍ التقديم..",
    accDetail: "تفاصيل الحساب :-",
    accnumber: "رقم الحساب",
    area: "المنطقة",
    areacode: "كود المنطقة",
    latitude: "خط العرض",
    longitude: "خط الطول",
    importdb: "استيراد قاعدة البيانات الرئيسية",
    exportData: "إصدار البيانات",
    downloading: "جاري التحميل...",
    viewGuideline: "عرض الإرشادات",
    createWorkflow: "إنشاء سير عمل جديد",
    selectOrgWarning: "حدد المنظمة أولاً",

    guidline: "المبادئ التوجيهية",
    noworkflow: "لا توجد مسارات عمل متاحة",
    pleaseselect: " الرجاء تحديد سير العمل أولاً.",

    //worklog
    email: "جدولة تقرير البريد الإلكتروني",
    export: "إصدار التقارير",
    pdf: "إصدار الملفاتPDF",
    todo: "مهام",
    loading: "جاري تحميل المزيد من سجل العمل...",
    nomore: "لا مزيد من سجل العمل للتحميل",
    name: "الحساب المحمي",
    createacc: "إنشاء حساب جديد",
    editacc: "تحرير الحساب المحمي",
    createproacc: "إنشاء حساب محمي",
    permanent: "الحماية الدائمة",
    protectionValid: "الحماية صالحة ل",
    createdBy: "تم إنشاؤها بواسطة",
    accProtection: "حماية الحساب لجميع الأنشطة",
    accno: "رقم الحساب ",
    remark: "ملاحظات",

    enterremark: "أدخل ملاحظاتك هنا",
    updatemeterDEtail: "تحديث تفاصيل العداد",
    downloadsheet: "تحميل الورقة",
    uploadinventory: "تحميل ورقة الجرد",
    reportType: "نوع التقرير",
    form: "طلب تقرير",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    orglist: "قائمة المنظمات",
    createOrg: " إنشاء منظمة",
    noOrg: "لا توجد بيانات المنظمة المتاحة.",
    rows: "عدد الصفوف في كل صفحة ",
    orgname: "اسم المنظمة",
    img: "تحميل الشعار",
    creating: "جارٍ الإنشاء...",
    updateOrg: "تحديث المنظمة",
    Updating: "جارٍ التحديث...",
    nolog: "لا يوجد شعار",
    number: "لا.",
    geoCodes :"رموز جغرافية مختارة",
    typeCodes :"رموز النوع المحددة",
    amountRange :"نطاق المبلغ المحدد",
    assignAll :"تعيين الكل",
    default:"تقصير",
    select: " حدد النشاط",
    selecteOrgName: " اختر المنظمة",
    selectsubactivty: " حدد النشاط الفرعي ",

    emailreport: "جدولة تقرير البريد الإلكتروني",
    selectactivity: "اختر النشاط:",
    recipients: "المستلمون",
    bcc: "نسخة مخفية الوجهة",
    cc: "نسخة",
    sendreport: "إرسال التقرير المقرر",
    senddashboard: "إرسال لوحة المعلومات:",
    shedulesend: "جدول الإرسال:",
    daily: "يوميًا",
    weekly: "أسبوعي",
    monthly: "شهريا",
    send: "يرسل",
    reportbtn: "طلب تقرير",
    report: "التقارير",


    stockmanag: "إدارة المخزون",
    fromdate: "من التاريخ ",
    todate: "إلى التاريخ ",
    metercode: "رمز شريط العداد",
    location: "إلى الموقع",
    filter: "تطبيق الفلترة",
    uploadSheet: "رفع الملف",
    visitTime: "وقت الزيارة ",
    visitDate: "تاريخ الزيارة ",
    nopdfavb: "لا يتوفر ملف PDF ",

    // login
    Utilities: "المرافق و",
    TasksManagementSolutions: "حلول إدارة المهام",
    UsernameEmailAddress: "اسم المستخدم / عنوان البريد الإلكتروني",
    RememberMe: "تذكرنى",
    ForgotPassword: "هل نسيت كلمة السر؟",
    assetBarCode: "(رمز الاستجابة للأصول (الباركود",
    dragAndDropDocuments: "اسحب وأفلت المستندات",
    viewDocuments: "عرض المستندات",
    uploadedDocument: "المستند المُحمّل",
    maxFileSize5MB: "الحد الأقصى لحجم الملف: 5 ميغابايت",
    browse: "تصفح",
    description: "الوصف",
    kilometer: "كيلومتر",
    noAccountDetialsAvailable: "لا توجد تفاصيل حساب متاحة",
    uploading: "جارٍ التحميل",
    upload: "تحميل",
    addOrganization: "إضافة مؤسسة",
    addDepartment: "إضافة قسم",
    uploadOrganizationLogo: "تحميل شعار المؤسسة",
    successMessage: ".يرجى الانتظار! يتم حالياً تحميل الملف. قد يستغرق ذلك بعض الوقت، وبمجرد اكتمال التحميل بنجاح، ستتلقى رسالة تأكيد",
    fullName: "الاسم الكامل",
    department: "القسم",
    project: "المشروع",
    profileImage: "صورة الملف الشخصي",
    vehicleId: "معرف المركبة",
    vehicleKM: "(KM) ممشى المركبة",
    vehicleAssinged: "المركبة المعينة",
    editPrivileges: "صلاحيات التعديل",
    source: "المصدر",
    thecustomcodewarningmessage: "لم يتم إضافة لون العلامة المخصصة، الرجاء الاختيار من القائمة أدناه!!",
    selectWorkflowFirst: "يرجى اختيار سير العمل أولاً",
    makerColor: "تم حفظ ألوان العلامات بنجاح",
    failedtoSaveMakerColor: "فشل في حفظ ألوان العلامات",
    permanentProtection: "الحماية الدائمة لن تحتوي على تاريخ انتهاء",
    noRecordAvailable: "لا توجد سجلات متاحة",
    reportGenerating: "جاري توليد التقرير...",
    mediumPriority: "أولوية متوسطة",
    highPriority: "أولوية عالية",
    lowPriority: "أولوية منخفضة",
    fillFieldbeforeAddVehical: "يرجى تعبئة جميع الحقول قبل إضافة المركبة",
    failToAddVehical: "فشل في إضافة المركبة",
    accountProtection:"حماية الحساب",
    clockIn:"الساعة في",
    clockOut:"خارج الساعة",
    English: "إنجليزي",
    Urdu:"الأردية",
    Arabic:"عربي",
    History: "تاريخ",
    Heading: "عنوان",
    Name: "اسم",
    Email: "بريد إلكتروني",
    Phone: "هاتف",
    Address: "عنوان",
    DatePicker: "منتقي التاريخ",
    TakePhoto: "التقط صورة",
    Signature: "إمضاء",
    RadioButton: "زر الراديو",
    Checkbox: "خانة الاختيار",
    Dropdown: "اسقاط",
    Number: "رقم",
    Time: "وقت",
    LongText: "نص طويل",
    Barcode: "الباركود",
    NotificationSound:"صوت الإخطار",
    TestSound:"اختبار الصوت",
    Configurations:"التكوينات",
    TermsAndConditions:"الشروط والأحكام",
    DragDropTermsConditionFile:"اسحب وأفلِت ملف الشروط والأحكام",
    PrivacyAcceptance:"قبول الخصوصية",
    DragDropPrivacyAcceptanceFile :"اسحب وأفلِت ملف قبول الخصوصية",
    TermsandConditionPdf:"الشروط والحالة.pdf",
    view:"منظر",
    NoReportDataavailble:"لا توجد بيانات تقرير متاحة",
    UnexpectedResponseFormat:"تنسيق رد غير متوقع. يُرجى المحاولة مرة أخرى.",
    chooseFile: "اختر ملف",
    noFile: "لم يتم اختيار أي ملف",
    PasswordRequired:"كلمة المرور مطلوبة",
    PasswordMustBeAtLeast8Characters:"يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
    IncludeDeletedRecords:"تضمين السجلات المحذوفة",
  },
  ur: {
    entername: 'نام درج کریں۔',
    Activities: 'سرگرمیاں',
    basicField: ' بنیادی فیلڈز',
    selectionfield: 'انتخاب کا میدان',
    mediafield: 'میڈیا اور خصوصی فیلڈز',
    items: 'چیزیں',
    Enable: 'فعال کریں۔',
    disable: 'غیر فعال',
    comapletedDate: ' مکمل ہونے کی تاریخ',
    taskId: 'ٹاسک آئی ڈی',
    noproject: 'لکوئی پروجیکٹ نہیں۔',
    nodepartment: ' کوئی محکمہ نہیں۔',
    noactivity: ' لکوئی سرگرمی نہیں۔',
    splaignrule: 'خصوصی تفویض کا اصول  ',
    myprofile: ' میرا پروفائل ',
    barChart: ' بار چارٹ ',
    Piechart: 'پائی چارٹ',
    Radarchart: 'ریڈار چارٹ',
    Linechart: 'لائن چارٹ',
    Areachart: 'ایریا چارٹ',
    OrganizationLogo: 'تنظیم کا لوگو',
    OrganizationName: 'تنظیم کا نام',
    OrganizationId: 'تنظیم کی شناخت',
    Organizations: 'تنظیمیں',
    ReportType: 'رپورٹ کی قسم',
    ForInstallmentPlan: 'قسط کے منصوبے کے لیے',
    WorkflowNames: 'ورک فلو کے نام',
    ReportLink: 'رپورٹ کا لنک',
    RequestedAt: 'پر درخواست کی۔',
    Noguidelines: 'کوئی رہنما خطوط دستیاب نہیں ہیں۔',
    Deleteworkflowmsg: 'کیا آپ واقعی چھوڑنا چاہتے ہیں؟ یہ عمل آپ کے بنائے گئے ورک فلو ڈھانچے کو حذف کر دے گا۔',
    MandatoryFields: 'لازمی فیلڈ',
    NonMandatoryFields: 'غیر لازمی فیلڈز',
    BulkUpload: 'بلک اپ لوڈ',
    CreateandAssigne: 'بنائیں اور تفویض کریں۔',
    AssetName: 'اثاثہ کا نام',
    UserId: 'یوزر آئی ڈی',
    FieldStaffList: "فیلڈ سٹاف کی فہرست",
    SUBMISSION: 'جمع کروانا',
    NOT_COMPLETED: 'مکمل نہیں ہوا۔',
    HideCriteria: "معیار چھپائیں۔",
    NewCriteria: 'نیا معیار شامل کریں۔',
    ActivityQuestions: 'سرگرمی کے سوالات کو منتخب کریں۔',
    FieldQuestion: 'فیلڈ سوال منتخب کریں۔',
    Select: 'منتخب کریں۔',
    AddChart: 'چارٹ شامل کریں۔',
    DeleteDash: 'کیا آپ واقعی اس ڈیش بورڈ کو حذف کرنا چاہتے ہیں؟',
    DeleteGraph: 'کیا آپ واقعی اس گراف میٹرک کو حذف کرنا چاہتے ہیں؟',
    CreateDash: 'ایکٹیویٹی ڈیش بورڈ بنائیں',
    Role: 'کردار',
    Activity: 'سرگرمی',
    ActivityName: 'سرگرمی کا نام',
    SelectChart: 'چارٹ منتخب کریں۔',
    ViewChart: 'چارٹ دیکھیں',
    RangeFilter: 'تاریخ کی حد کا فلٹر',
    selecrOrg: 'براہ کرم ایک تنظیم منتخب کریں۔',
    Page: 'صفحہ',
    FieldId: 'فیلڈ ایجنٹ کی شناخت',
    FieldAgentName: 'فیلڈ ایجنٹ کا نام',
    NoasssingData: 'تفویض کرنے والا کوئی ڈیٹا دستیاب نہیں ہے۔',
    Action: 'ایکشن',
    RemarkReq: 'کسٹمر سپورٹ شامل کریں۔',
    adCustSupport: 'کسٹمر سپورٹ شامل کریں۔',
    Clone: 'کلون',
    SpecialRc: 'خاص RC',
    InteractiveRc: 'انٹرایکٹو RC',
    Viewinstallment: 'قسط دیکھیں',
    createInstallment: 'قسط کا منصوبہ بنائیں',
    CustomerId: 'کسٹمر آئی ڈی',
    NoOfinstallment: 'قسطوں کی تعداد',
    advancepayamt: 'پیشگی ادائیگی کی رقم',
    advDate: 'پیشگی تاریخ',
    custDetail: 'کسٹمر کی تفصیلات',
    instalDetail: 'قسط کی تفصیلات',
    firstInstDate: 'پہلی قسط کی تاریخ',
    clrPreview: 'پیش نظارہ صاف کریں۔',
    prevPlan: 'پیش نظارہ پلان',
    submitRc: 'کے لیے جمع کروائیں۔ Rc',
    AfterAdv: 'پیشگی کے بعد بقایا',
    currentOut: 'موجودہ بقایا',
    payDate: 'ادائیگی کی تاریخ',
    Amount: 'رقم ',
    Notes: 'نوٹس ',
    Latitude: 'عرض بلد ',
    Longitude: 'طول البلد ',
    selectFieldAget: 'فیلڈ ایجنٹ کو منتخب کریں۔',
    planId: 'پلان آئی ڈی',
    planActive: 'فعال منصوبہ',
    planCreated: 'منصوبہ بنایا',
    outstaningAmt: 'بقایا رقم',
    Advamt: 'ایڈوانس رقم',
    AdvDate: 'پیشگی ادائیگی کی تاریخ',
    firstInsDate: 'پہلی قسط کی تاریخ',
    noOfInst: 'قسطوں کی تعداد',
    activeInst: 'فعال قسطیں',
    DetailId: 'تفصیلی شناخت ',
    PaymentId: 'ادائیگی کی شناخت',
    PayAmt: 'ادائیگی کی رقم',
    payDate: 'ادائیگی کی تاریخ',
    Status: 'حیثیت ',
    PayPrev: 'ادائیگی کا پیش نظارہ',
    OutAfteAdv: 'پیشگی کے بعد بقایا',
    CurrentOut: 'موجودہ بقایا',
    NoinstAvlble: 'کوئی قسط دستیاب نہیں۔',
    title: 'Blufield یوٹیلیٹیز ٹاسک مینجمنٹ سلوشنز',
    userEmail: 'صارف نام/ای میل پتہ',
    password: 'پاس ورڈ ',
    remember: 'مجھے یاد رکھنا',
    forgetpass: 'پاس ورڈ بھول جائیں۔',
    Login: 'لاگ ان ',

    pressEnter: 'متعدد اکاؤنٹ نمبرز شامل کرنے کے لیے Enter دبائیں۔',
    typeEnter: 'ایک نمبر ٹائپ کریں اور انٹر دبائیں۔',
    Phone: 'فون',
    payDetail: 'ادائیگی کی تفصیلات',
    cretDate: 'تخلیق کی تاریخ',
    inactiveplane: 'غیر فعال قسطوں کے منصوبے',
    instplanDetail: 'قسط کے منصوبے کی تفصیلات',
    loogoutMsg: 'کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟',
    Logout: "لاگ آؤٹ",
    support: "کسٹمر سپورٹ",
    supporttooltip: "سپورٹ سسٹم  Rc",
    installment: " قسط کا منصوبہ",
    downloadPdf: "پی ڈی ایف ڈاؤن لوڈ کریں۔",
    noDatavb: "کوئی ڈیٹا دستیاب نہیں ہے۔",
    viewValidation: "توثیق دیکھیں",
    refresh: "ٹیبل ریفریش کریں۔",
    discard: "رد کر دیں۔",
    Confirm: "تصدیق کریں۔",
    datefilterforchart: " مکمل کام کے لیے تاریخ کا فلٹر   ",
    updatetaskdetail: "ٹاسک کی تفصیلات کو اپ ڈیٹ کریں۔  ",
    completedTaskCount: "مکمل ٹاسک کاؤنٹ  ",
    priority: "کام کی ترجیح  ",
    taskstatus: "ٹاسک اسٹیٹس ",
    usercount: "صارف شمار",
    listvbiew: "ٹاسک لسٹ ویو  ",
    previous: "پچھلا",
    next: "اگلا",
    date: "تاریخ",
    from: "سے",
    to: "کو",
    apply: "لگائیں",
    unassignn: "إلغاء التعيين",
    dashboard: "لوحة القيادة",
    dashboardtolltip: "لوحة القيادة، عرض وإدارة نظرة عامة على لوحة القيادة",
    usertooltip: "المستخدمون، إدارة حسابات المستخدمين والأدوار",
    setting: "الإعدادات",
    asset: "إدارة الأصول",
    assettooltip: "الأصول، عرض وإدارة الأصول الخاصة بك",
    config: "التكوين",
    configtooltip: "التكوين، إدارة قواعد التعيين، القواعد المخصصة وقواعد الإتمام",
    task: "إدارة المهام",
    tasktooltip: "إدارة المهام، إدارة مهامك وتعييناتك، والحذف",
    acchistory: "تاريخ الحساب",
    historytooltip: "تاريخ الحساب، عرض تاريخ المهام المكتملة",
    workflowe: "سير العمل",
    workflowtooltip: "سير العمل، إدارة سير العمل الخاص بك، الإرشادات",
    worklog: "سجل العمل",
    worklogtooltip: "سجل العمل، عرض وإدارة سجلات العمل الخاصة بك، تصدير تقرير Excel، تصدير PDF",
    security: "الأمان",
    securitytooltip: "الأمان، إدارة إعدادات الأمان",
    report: "التقارير",
    reportooltip: "التقارير، طلب تقرير، التحقق من حالة التقارير",
    org: "المنظمة",

    orgtooltip: "المنظمة، إدارة المنظمة",
    stock: "إدارة المخزون",
    stocktoooltip: "إدارة المخزون، تحديث تفاصيل المخزون، تنزيل التقرير",
    addUser: "إضافة مستخدم",
    searchusername: "البحث بواسطة اسم المستخدم...",
    searchareacode: "البحث بواسطة رمز المنطقة...",
    userType: "نوع المستخدم",
    user: "مستخدم",
    edit: "تعديل",
    userlist: "إدارة المستخدمين",
    userdetail: "تفاصيل المستخدم",
    previllage: "الامتيازات",
    cancle: "إلغاء",
    updateuser: "تحديث المستخدم",
    add: "إضافة مستخدم",
    username: "إضافة مستخدم",
    Email: "البريد الإلكتروني",
    selectOrg: "اختيار المنظمة",
    areCode: "رمز المنطقة",
    addeditActivity: "إضافة/تعديل النشاط",
    addnewlabel: "إضافة/تعديل التكوين",
    addEdituser: "صارف کو شامل/ترمیم کریں۔",
    canasset: "يمكن الوصول إلى إدارة الأصول",
    uservisibility: "رؤية المستخدم",
    modifyguidline: "تعديل الإرشادات",
    createDashboar: "إنشاء لوحة القيادة",
    addeditleader: "إضافة/تعديل لوحة القيادة",
    canTaskManage: "يمكن الوصول إلى إدارة المهام",
    canAddEditProtectedAccount: "يمكن إضافة/تعديل الحساب المحمي",
    canAddEditInventory: "يمكن إضافة/تعديل إدارة المخزون",
    general: "عام",
    save: "حفظ التغييرات",
    langSetting: "إعدادات اللغة ",
    colormode: "وضع اللون ",
    light: "فاتح",
    dark: "داكن",
    highcontrast: "تباين عالي",
    lang: "اللغة",
    toursetting: "إعدادات الجولة",
    stoptour: "إيقاف الجولة",
    starttour: "بدء الجولة",
    custommarker: "علامة مخصصة",
    all: "الكل",
    assigned: "مخصص",
    active: "فعال ",
    progress: "قيد التقدم",
    completed: "مكتمل",
    onhold: "معلق",
    //ASSET
    vehical: "مركبة",
    Inventory: "المخزون",
    exportreport: "تصدير التقرير",
    addVehical: "إضافة مركبة جديدة",
    addAsset: "إضافة أصل جديد",
    search: "بحث",
    vehicalType: "نوع المركبة",
    vehicalAssign: "مخصص المركبة",
    searchbyId: "البحث بواسطة المعرف...",
    assetType: "نوع الأصل",
    assetAssign: "مخصص الأصل",
    addnewasset: "إضافة أصل جديد",
    assetId: "اثاثہ کی شناخت",
    agentAssigned: "ایجنٹ تفویض",
    assetStatus: "اثاثہ کی حیثیت",
    updateAsset: "تحديث الأصل",
    Update: "تحديث",
    updateVehical: "تحديث المركبة",
    //CONFIGURATION
    complitionrule: "قواعد الإتمام",
    assignment: "قواعد التعيين",
    customerule: "المتغيرات المخصصة",
    rulename: "اسم القاعدة",
    assignTo: "التعيين إلى",
    activedeactive: "نشط / غير نشط",
    criteria: "المعايير",
    submit: "إرسال",
    update: "اپ ڈیٹ کریں۔",
    norule: "لا توجد قواعد لتحميلها",
    icon: "أيقونة",
    createrule: "إنشاء قاعدة جديدة",
    //TASKMANAGE
    multiSelect: "تحديد متعدد",
    smartAssign: "التعيين الذكي",
    FieldStaff:"فیلڈ سٹاف",
    Location:"مقام",
    MapStatus:"نقشہ کی حیثیت",
    fieldAgent: "وكيل ميداني",
    createNewTask: "إنشاء مهمة جديدة",
    importCSV: "رفع المهمة",
    mapview: "عرض الخريطة",
    createTask: "إنشاء مهمة جديدة",
    download: "تنزيل",
    deleteAllRecord: "حذف جميع السجلات",
    assign: "تعيين",
    reassign: "إعادة تعيين",
    alert: "إرسال تنبيه",
    delete: "حذف",
    priority: "الأولوية",
    status: "الحالة",
    searchbycode: "البحث بواسطة رمز المنطقة..",
    selectAssign: "اختيار المعين",
    downloadtask: "تنزيل تقرير المهمة",
    seectallactivty: "تحديد جميع الأنشطة",
    selectpartcular: "اختيار نشاط معين",
    selectMsg: "يرجى تحديد نشاط للمتابعة.",
    createnewtask: "إنشاء مهمة جديدة",
    cancel: "إلغاء",
    create: "إنشاء",
    DragDetail: "اسحب وأفلت ملف CSV الذي يحتوي على جميع تفاصيل المهام",
    sizeMsg: "الحد الأقصى لحجم الملف: 15 ميجابايت",
    import: "استيراد CSV",
    uploadfile: "رفع ورقة المهام",
    uploadby: "تم الرفع بواسطة",
    uploaddate: "تاريخ الرفع",
    uploadtime: "وقت الرفع (24 ساعة)",
    taskdetail: "تفاصيل المهمة",
    taskhistory: "تاريخ المهمة",
    nohistory: "لا توجد تاريخ للمهمة.",
    more: "جاري تحميل المزيد من تاريخ المهام...",
    enteraccno: "أدخل رقم الحساب",
    reset: "إعادة تعيين",
    submitting: "جاري الإرسال..",
    accDetail: "تفاصيل الحساب",
    accnumber: "رقم الحساب",
    area: "المنطقة",
    areacode: "رمز المنطقة",
    latitude: "خط العرض",
    longitude: "خط الطول",
    importdb: "استيراد قاعدة البيانات الرئيسية",
    exportData: "تصدير التقرير",
    downloading: "جاري التنزيل...",
    viewGuideline: "عرض الإرشادات",
    createWorkflow: "إنشاء سير عمل جديد",
    selectOrgWarning: "حدد المنظمة أولاً",
    guidline: "الإرشادات",
    noworkflow: "لا توجد سير عمل متاحة",
    pleaseselect: "يرجى تحديد سير العمل أولاً.",
    email: "جدولة تقرير عبر البريد الإلكتروني",
    export: "تصدير التقرير",
    pdf: "تصدير PDF",
    todo: "قيد التنفيذ",
    loading: "جاري تحميل المزيد من سجل العمل...",
    nomore: "لا توجد المزيد من سجلات العمل لتحميلها",
    name: "حساب محمي",
    createacc: "إنشاء حساب جديد",
    editacc: "تعديل الحساب المحمي",
    createproacc: "إنشاء حساب محمي",
    permanent: "حماية دائمة",
    protectionValid: "تحفظ درست ہے۔",
    createdBy: "کی طرف سے پیدا کیا",
    accProtection: "حماية الحساب لجميع الأنشطة",
    accno: "رقم الحساب",
    remark: "ملاحظات",
    enterremark: "أدخل ملاحظاتك هنا",
    updatemeterDEtail: "تحديث تفاصيل العداد",
    downloadsheet: "تنزيل الورقة",
    uploadinventory: "رفع ورقة المخزون",
    reportType: "نوع التقرير",

    form: "طلب تقرير",
    uploadSheet: "رفع الورقة",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    request: "طلب",

    orglist: "قائمة المنظمات",
    createOrg: "إنشاء منظمة",
    noOrg: "لا توجد بيانات للمنظمة.",
    rows: "الصفوف لكل صفحة",
    orgname: "اسم المنظمة",
    img: "رفع الشعار",

    creating: "جاري الإنشاء...",
    updateOrg: "تحديث المنظمة",

    Updating: "جاري التحديث...",
    nolog: "لا يوجد شعار",
    number: "لنہیں",
    geoCodes :"منتخب جیو کوڈز",
    typeCodes :"منتخب قسم کے کوڈز",
    amountRange :"منتخب کردہ رقم کی حد", 
    assignAll :"سب کو تفویض کریں۔",
    default:"طے شدہ",
    assingTask: 'کام تفویض کریں۔',
    //dashbord
    userdashboard: "لوحة القيادة للمستخدم",
    activitydashboard: "لوحة القيادة للنشاط",
    admin: "مسؤول",
    office_user: "المستخدمون في المكتب",
    field_agent: "وكلاء ميدانيون",
    dashboardName: "اسم لوحة القيادة",
    addnewDashboard: "إضافة لوحة قيادة جديدة",
    chartMessage: "حدد لوحة القيادة لعرض الرسوم البيانية",
    deletDashbord: "حذف لوحة القيادة",
    //notifucation
    notification: "إشعار",
    allnotification: "جميع الإشعارات",
    profile: "الملف الشخصي",
    select: "اختيار النشاط",
    selecteOrgName: "اختيار اسم المنظمة",
    selectsubactivty: "اختيار النشاط الفرعي",

    emailreport: "جدولة تقرير عبر البريد الإلكتروني",
    selectactivity: "اختيار النشاط:",
    recipients: "المستلمون",
    bcc: "نسخة مخفية",
    cc: "نسخة",
    sendreport: "إرسال التقرير المجدول",
    senddashboard: "إرسال لوحة القيادة:",
    shedulesend: "جدولة الإرسال:",
    daily: "يومي",
    weekly: "أسبوعي",
    monthly: "شهري",

    send: "إرسال",
    reportbtn: "طلب تقرير",
    report: "التقارير",

    stockmanag: "إدارة المخزون",
    fromdate: "من تاريخ",
    todate: "إلى تاريخ",
    metercode: "رمز بار العداد",
    location: "إلى الموقع",
    filter: "تطبيق الفلاتر",
    addbtn: "إضافة",
    visitTime: "وزٹ ٹائم",
    visitDate: " وزٹ کی تاریخ ",
    nopdfavb: "کوئی PDF دستیاب نہیں ہے۔ ",

    // login
    Utilities: "افادیت اور",
    TasksManagementSolutions: "ٹاسک مینجمنٹ کے حل",
    UsernameEmailAddress: "صارف نام / ای میل ایڈریس",
    RememberMe: "مجھے یاد رکھنا",
    ForgotPassword: "اپنا پاس ورڈ بھول گئے؟",
    assetBarCode: "اثاثہ بارکوڈ",
    dragAndDropDocuments: "دستاویزات کو گھسیٹیں اور چھوڑیں۔",
    viewDocuments: "دستاویز دیکھیں",
    uploadedDocument: "اپ لوڈ کردہ دستاویز",
    maxFileSize5MB: "زیادہ سے زیادہ فائل کا سائز: 5MB",
    browse: "براؤز کریں۔",
    description: "تفصیل",
    kilometer: "کلومیٹر",
    noAccountDetialsAvailable: "اکاؤنٹ کی کوئی تفصیلات دستیاب نہیں ہیں۔",
    uploading: "اپ لوڈ ہو رہا ہے۔",
    upload: "اپ لوڈ کریں۔",
    addOrganization: "تنظیم شامل کریں۔",
    addDepartment: "محکمہ شامل کریں۔",
    uploadOrganizationLogo: "تنظیم کا لوگو اپ لوڈ کریں۔",
    successMessage: "براہ مہربانی انتظار کریں! فائل اپ لوڈ ہو رہی ہے۔ اس میں کچھ وقت لگ سکتا ہے، اور کامیابی سے اپ لوڈ ہونے کے بعد، آپ کو کامیابی کا پیغام موصول ہوگا۔",
    fullName: "پورا نام",
    department: "محکمہ",
    project: "پروجیکٹ",
    profileImage: "پروفائل امیج",
    vehicleId: "گاڑی کی شناخت",
    vehicleKM: "گاڑی (KM)",
    vehicleAssinged: "گاڑی تفویض کی گئی۔",
    editPrivileges: "مراعات میں ترمیم کریں۔",
    source: "ماخذ",
    thecustomcodewarningmessage: "حسب ضرورت مارکر رنگ شامل نہیں کیا گیا، نیچے سے منتخب کریں!!",
    selectWorkflowFirst: "پہلے ورک فلو کو منتخب کریں۔",
    makerColor: "مارکر رنگ کامیابی سے محفوظ ہو گئے!",
    failedtoSaveMakerColor: "مارکر کا رنگ محفوظ کرنے میں ناکام!",
    permanentProtection: "مستقل تحفظ کی آخری تاریخ نہیں ہوگی۔",
    noRecordAvailable: "کوئی ریکارڈ دستیاب نہیں۔",
    reportGenerating: "رپورٹ تیار ہو رہی ہے...",
    mediumPriority: "درمیانی ترجیح",
    highPriority: "اعلیٰ ترجیح",
    lowPriority: "کم ترجیح",
    fillFieldbeforeAddVehical: "گاڑی کو شامل کرنے سے پہلے براہ کرم تمام فیلڈ کو پُر کریں۔",
    failToAddVehical: "گاڑیاں شامل کرنے میں ناکام",
    accountProtection:"اکاؤنٹ کا تحفظ",
    clockIn:"گھڑی میں",
    clockOut:"گھڑی باہر",
    English: "انگریزی",
    Urdu:"اردو",
    Arabic:"عربی",
    History: "تاریخ",
    Heading: "سرخی",
    Name: "نام",
    Email: "ای میل",
    Phone: "فون",
    Address: "پتہ",
    DatePicker: "تاریخ چننے والا",
    TakePhoto: "تصویر لیں",
    Signature: "دستخط",
    RadioButton: "ریڈیو بٹن",
    Checkbox: "چیک باکس",
    Dropdown: "ڈراپ ڈاؤن",
    Number: "نمبر",
    Time: "وقت",
    LongText: "لمبا متن",
    Barcode: "بارکوڈ",
    NotificationSound:"اطلاع کی آواز",
    TestSound:"ٹیسٹ ساؤنڈ",
    Configurations:"کنفیگریشنز",
    TermsAndConditions:"شرائط و ضوابط",
    DragDropTermsConditionFile:"شرائط و ضوابط کی فائل کو گھسیٹ کر چھوڑیں۔",
    PrivacyAcceptance:"رازداری کی قبولیت",
    DragDropPrivacyAcceptanceFile :"رازداری کی قبولیت فائل کو گھسیٹیں اور چھوڑیں۔",
    TermsandConditionPdf:"شرائط و ضوابط.pdf",
    view:"دیکھیں",
    NoReportDataavailble:"کوئی رپورٹ ڈیٹا دستیاب نہیں ہے۔",
    UnexpectedResponseFormat:"غیر متوقع جوابی شکل۔ براہ کرم دوبارہ کوشش کریں۔",
    chooseFile: "فائل کا انتخاب کریں۔",
    noFile: "کوئی فائل منتخب نہیں کی گئی۔",
    PasswordRequired:"پاس ورڈ درکار ہے۔",
    PasswordMustBeAtLeast8Characters:"پاس ورڈ کم از کم 8 حروف کا ہونا چاہیے۔",
    IncludeDeletedRecords:"حذف شدہ ریکارڈز شامل کریں۔",
  }
};

export default translations;
